import { Icons } from '../../Components/Icons/Icons';
import { TableColumn, TableResource } from './types';

export const TABLE_COLUMNS: TableColumn[] = [
  {
    id: 'thumbnail',
    label: 'Thumbnail',
    width: '10%',
  },
  {
    id: 'name',
    label: 'Name',
    width: '20%',
  },
  {
    id: 'agency',
    label: 'Agency',
    width: '30%',
    render: (row: TableResource) => row.agency.name,
  },
  {
    id: 'category',
    label: 'Category',
    width: '10%',
    render: (row: TableResource) => row.category.name,
  },
  {
    id: 'type',
    label: 'Type',
    width: '10%',
  },
  {
    id: 'date',
    label: 'Date',
    width: '10%',
    render: (row: TableResource) => {
      const date = new Date(row.createdAt);
      const day = date.getDate().toString().padStart(2, '0');
      const month = (date.getMonth() + 1).toString().padStart(2, '0');
      return `${month}/${day}/${date.getFullYear()}`;
    },
  },
  {
    id: 'action',
    label: 'Action',
    width: '10%',
    render: (row: TableResource, onDelete, onDownload, isShowAddNewResourceButton) => (
      <div className="action-icons">
        {row.type === 'link' ? (
          <a className="link-icon" href={row.sourcePath} target="_blank" rel="noopener noreferrer">
            {Icons.Link}
          </a>
        ) : (
          <button className="download-icon" onClick={() => onDownload?.(row.id)}>
            {Icons.Download}
          </button>
        )}
        {isShowAddNewResourceButton && (
          <span className="delete-icon" onClick={() => onDelete?.(row.id)}>
            {Icons.Delete}
          </span>
        )}
      </div>
    ),
  },
];
